module.exports = __webpack_public_path__ + "static/media/ee.6088c9ce.svg";